import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import { blogs } from '../data';

function Blogs() {
  return (
    <Box sx={{ py: 1 }}>
      <Box sx={{ mb: 3.5, textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 800, color: '#00a2ff', fontFamily: "'Share Tech Mono', monospace" }}>
          [ Threat Intelligence & Technical Writeups ]
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '500px', mx: 'auto', fontSize: '0.85rem' }}>
          Deep-dives, cybersecurity tutorials, tool configurations, and walkthroughs written for Threat Radar.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {blogs.map((blog, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'space-between',
                p: 1,
                border: '1px solid #1c2536',
                background: '#0d1017',
                '&:hover': {
                  borderColor: 'rgba(0, 162, 255, 0.3) !important',
                  '& .read-btn': {
                    color: '#00a2ff',
                  },
                  '& .btn-arrow': {
                    transform: 'translateX(4px)',
                  }
                }
              }}
            >
              <CardContent sx={{ p: 1.5, pb: 1 }}>
                <Box sx={{ display: 'flex', gap: 1.2, alignItems: 'flex-start', mb: 1.2 }}>
                  <Box 
                    sx={{ 
                      p: 0.8, 
                      bgcolor: 'rgba(0, 162, 255, 0.08)', 
                      color: '#00a2ff', 
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <ArticleIcon sx={{ fontSize: '1.2rem' }} />
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="body2" component="h2" sx={{ fontWeight: 700, fontSize: '0.9rem', lineHeight: 1.2, color: '#ffffff', fontFamily: "'Share Tech Mono', monospace" }}>
                      {blog.title}
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, fontSize: '0.8rem', lineHeight: 1.4 }}>
                  {blog.description}
                </Typography>
                
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {blog.tags.map((tag) => (
                    <Chip 
                      key={tag} 
                      label={tag} 
                      size="small" 
                      sx={{ 
                        bgcolor: 'rgba(0, 162, 255, 0.04)', 
                        color: '#9ca3af', 
                        fontSize: '0.65rem',
                        fontWeight: 600,
                        border: '1px solid rgba(255, 255, 255, 0.06)',
                        height: 16,
                        '& .MuiChip-label': { px: 0.6 }
                      }} 
                    />
                  ))}
                </Box>
              </CardContent>
              <Box sx={{ p: 1.5, pt: 0, display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                  className="read-btn"
                  variant="text" 
                  color="primary"
                  size="small" 
                  href={blog.link} 
                  target="_blank"
                  endIcon={<ArrowRightAltIcon className="btn-arrow" sx={{ fontSize: '1rem', transition: 'transform 0.2s ease' }} />}
                  sx={{ fontWeight: 700, fontSize: '0.72rem', py: 0.2 }}
                >
                  Read Article
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Blogs;
